import { throwForFailedResponse } from "@/lib/errors/error-handler";
import { Gift } from "@/types/gift";

async function getJson<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options?.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));

  if (!res.ok || data?.success === false) {
    throwForFailedResponse(res, data, "Request failed");
  }
  return (data?.data ?? data) as T;
}

async function postJson(path: string, body: unknown) {
  const res = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    credentials: "include",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throwForFailedResponse(res, data, "Failed to complete request");
  }
  return data;
}

export const giftService = {
  async getGift(token: string): Promise<Gift> {
    const params = new URLSearchParams();
    params.append("token", token);
    return getJson<Gift>(`/api/gift?${params.toString()}`);
  },

  async reveal(payload: { reveal: boolean; token: string }) {
    return postJson("/api/gift", payload);
  },

  async option() {
    return getJson<{ id: number; name: string }[]>(`/api/gift/option`);
  },

  async getAll() {
    return getJson(`/api/gift/video`);
  },

  async download(token: string): Promise<Gift> {
    const params = new URLSearchParams();
    params.append("token", token);
    return getJson<Gift>(`/api/gift/download?${params.toString()}`);
  },
};
